import { inject, Injectable } from '@angular/core';
import { CityCacheService } from './city-cache.service';
import { Region } from 'angular-api-gateway/v1/model/region';
import { CityStoreFacade } from '@lentau/city/store/city.facade';
import { CitySlugCacheService } from './city-slug-cache.service';

@Injectable({
  providedIn: 'root',
})
export class CityCacheFacade {
  private cityFacade: CityStoreFacade = inject(CityStoreFacade);
  private cityCacheService: CityCacheService = inject(CityCacheService);
  private citySlugCacheService: CitySlugCacheService = inject(CitySlugCacheService);

  public init(): void {
    const city: Region = this.cityCacheService.getInitCity();

    if (city && city?.slug === this.citySlugCacheService.getInitCitySlug()) {
      this.cityFacade.setCity(city);
    }
  }
}
